import classnames from 'classnames';
import React, { ComponentPropsWithoutRef } from 'react';

import { Error } from '../error';
import { Label } from '../label';

import styles from './CheckBox.module.scss';

interface ICheckBoxProps extends ComponentPropsWithoutRef<'input'> {
  label: string;
  error?: string;
  disabledCheckbox?: boolean;
}

const CheckBox = ({
  className,
  id,
  label,
  checked,
  error,
  disabled,
  disabledCheckbox,
  onChange,
  ...rest
}: ICheckBoxProps) => {
  return (
    <div className={classnames(styles.root, 'position-relative', className)}>
      <Label
        className={classnames(styles.label, { [styles.disabled]: disabled })}
        htmlFor={id}
      >
        <input
          {...rest}
          id={id}
          className={classnames(styles.input, 'position-absolute invisible', {
            [styles.error]: error,
          })}
          type="checkbox"
          checked={checked}
          disabled={disabled}
          onChange={onChange}
        />
        <div
          className={classnames(
            {
              [styles.checkbox]: !disabledCheckbox,
              [styles.disabledCheckbox]: disabledCheckbox,
            },
            'position-absolute',
          )}
        />
        {label}
      </Label>

      {error && <Error className="mt-1">{error}</Error>}
    </div>
  );
};

export default CheckBox;
